import React, { useEffect, useRef, useState } from "react";

// scss
import "./assets/scss/theme.scss";

//Route
import Routes from "./routes";

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// api config
// import config from "./config";
import fakeBackend from "./helpers/fakeBackend";

import { SignalRProvider } from "../src/components/SignalRContext";
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { LogDb, Utils } from "helpers/utils";
import { APIClient } from "api/apiCore";
import * as urls from "api/urls";
import { UserStruct, UserTypes } from "api";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { setIsInFrame, setCurrentUser, clearCurrentUser, changeTab, changeSelectedChat, setActiveGroupId, getChatUserConversations2 } from "../src/redux/actions";
import { setActivePostId2, setFilterSelected, setIsEmbChatOnly } from "../src/redux/workplace/wpActions";
import { WorkPlaceTagFilter } from "../src/redux/workplace/wpTypes";
import { TABS } from "../src/constants/layout";
import { useLocation } from "react-router-dom";
import { Const, SKeys } from "const";
// import SignalRListener from "../src/components/SignalRListener";

const CustomAlert = (message: string, type: SweetAlertIcon = 'info') => {
  if (message) message = (message + '').replaceAll("\n", "<br/>");
  return Swal.fire({
    html: message,
    // text: message,
    icon: type,
    confirmButtonText: 'OK'
  });
};

// const SweetConfirm = (/*title:string,*/ confirmMessage:string) => {
//   return Swal.fire({
//     title: 'ยืนยัน',
//     html: confirmMessage,
//     icon: 'warning',
//     showCancelButton: true,
//     confirmButtonText: 'Yes, confirm',
//     cancelButtonText: 'Cancel',
//   });
// }

// TODO
fakeBackend();

// const firebaseConfig = {
//   apiKey: config.FIRE_BASE.API_KEY,
//   authDomain: config.FIRE_BASE.AUTH_DOMAIN,
//   databaseURL: config.FIRE_BASE.DATABASEURL,
//   projectId: config.FIRE_BASE.PROJECTID,
//   storageBucket: config.FIRE_BASE.STORAGEBUCKET,
//   messagingSenderId: config.FIRE_BASE.MESSAGINGSENDERID,
//   appId: config.FIRE_BASE.APPID,
//   measurementId: config.FIRE_BASE.MEASUREMENTID,
// };

// // init firebase backend
// initFirebaseBackend(firebaseConfig);

const App = () => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Profile2,
    (state: any) => state.Layout,
    (state, layout) => ({
      webUserId: state.webUserId,
      customerIsCdSys: state.customerIsCdSys,
      curUserId: state.userId,
      activeTab: layout.activeTab,
    })
  );
  const { webUserId, customerIsCdSys, curUserId, activeTab } = useAppSelector(storeData);
  const location = useLocation();
  const curUserIdRef = useRef(curUserId);
  const activeTabRef = useRef(activeTab);
  useEffect(() => { curUserIdRef.current = curUserId }, [curUserId]);
  useEffect(() => { activeTabRef.current = activeTab }, [activeTab]);
  useEffect(() => {
    Utils.WpDraft_ClearOldKey();
  }, []);

  useEffect(() => {
    try {
      const prev = localStorage.getItem("rts") ?? "";
      let path = location.pathname;
      if (prev != "") {
        path = path + "<-" + prev;
      } 
      if (path.length > 200) path = path.substring(0, 200);
      localStorage.setItem("rts", path);
    } catch (e) {
      console.error(e);
    }
  }, [location]);

  useEffect(() => {
    const handleLinkClick = async (e: MouseEvent) => {
      try {
        const target = e.target as HTMLElement;


        // Traverse up to find anchor tag (in case <span> or <img> inside <a>)
        const anchor = target.closest('a') as HTMLAnchorElement | null;
        if (!anchor) return;

        const href = anchor.getAttribute('href');
        if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;

        const needExternalParsing = Utils.IsUrlNeedExternalParsing('App', href, webUserId, customerIsCdSys);
        if (!needExternalParsing) {
          return;
        } else {
        }

        // Intercept only if it's a real link
        e.preventDefault();

        const newUrl = await Utils.GetExternalUrl('App', href ?? "", webUserId, customerIsCdSys);
        let linkTarget = anchor.getAttribute('target');

        // navigate
        // Check if Ctrl (Windows/Linux) or Cmd (Mac) is held
        if (linkTarget || e.ctrlKey || e.metaKey) {
          // Open in new tab
          if (!linkTarget) {
            linkTarget = "_blank";
          }
          // window.open(newUrl, '_blank');
          // alert(newUrl);
          const a = document.createElement('a');
          a.setAttribute('id', 'a-dmy');
          a.href = newUrl;
          if (!Utils.IsRunningInPWAMobile()) {
            a.target = linkTarget; // 20250708 in case of run in mobile, no need to set target to other because its will open replace the current view and have close button (but URL must not same domain)
          }
          // a.target = "_blank";
          // a.download = "file1.xls";
          // const isDesktop = Utils.IsDesktop();
          // const isPwa = Utils.IsRunningInPWA();
          // alert('desktop = ' + isDesktop + ', pwa = ' + isPwa);
          // alert('target = ' + a.target);
          // a.rel = 'noopener noreferrer';
          if (Utils.isApple) {
            window.location.href = newUrl;
          } else {
            a.click();
          }
        } else {
          // log.Write(`Chnage windows location to '${newUrl}'`);
          // Navigate in same tab
          //alert(newUrl);
          window.location.href = newUrl;
        }
      } catch (e) {
        Utils.HandleException(e, true);
      }
    };

    document.addEventListener('click', handleLinkClick);

    return () => {
      document.removeEventListener('click', handleLinkClick);
    };
  }, [webUserId, customerIsCdSys]);

  // const [runInFrame, setRunInFrame] = useState<boolean>(false);
  // const runInFrameRef = useRef(runInFrame);
  const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

  const [runInFrame, setRunInFrame] = useState<boolean>(false);
  const runInFrameRef = useRef(runInFrame);
  useEffect(() => {
    runInFrameRef.current = runInFrame;
    // console.log('setRunInFrame = ' + runInFrame);
  }, [runInFrame]);
  // useEffect(() => {
  //   const isInFrame = window.self !== window.top;
  //   console.log('[TEST] Is In Frame = ' + isInFrame);
  //   setRunInFrame(isInFrame);

  //   const handleMessage = async (event: MessageEvent) => {
  //     console.log('[TEST] handleMessage Is In Frame = ' + runInFrameRef.current);
  //   }

  //   window.addEventListener('message', handleMessage);

  //   return () => {
  //     window.removeEventListener('message', handleMessage);
  //   };
  // }, []);
  const [pathName, setPathName] = useState<string>("");
  // console.log("init location = " + pathName);
  const pathNameRef = useRef(pathName);
  useEffect(() => { setPathName(location.pathname); setRunInFrame(false); /*console.log('location changed to ', location.pathname);*/ }, [location]);
  useEffect(() => { pathNameRef.current = pathName }, [pathName]);

  useEffect(() => { // 20250621 Handle if its run inside iframe
    const isInFrame = window.self !== window.top;
    // setRunInFrame(isInFrame);
    console.log('run in iframe = ' + isInFrame);
    setRunInFrame(isInFrame);
    if (isInFrame) {
      dispatch(setIsInFrame(true));
    }

    const handleMessage = async (event: MessageEvent) => {
      // console.log('Got iFrame.postMessage:', event.data);
      // if (runInFrame) console.log('runInFrame = ' + runInFrame);
      const origin = event.origin?.toLowerCase();
      const isOriginAllowed =
        origin === "https://2smetal.com"
        || origin === "https://chat.2smetal.com"
        || origin === "https://chat9.2smetal.com"
        || origin === "https://chat_files.2smetal.com"
        || origin === "https://chat9_files.2smetal.com"
        || origin === "https://www.2smetal.com"
        || origin === "https://www.2sonline.net"
        || origin === "https://erp.2smetal.com"
        || origin === "https://u1.2sonline.net"
        || origin === "http://localhost:3000"
        //#define ACTIVE DEBUG_ORIGIN
        || origin === "https://localhost:44301"
        || origin === "https://localhost:5173"
        || origin.includes("localhost")
        || event.origin === 'null';

      if (!isOriginAllowed) {
        console.error('invalid origin');
        return;
      }
      const data = event.data;
      if (data.type == 'emb_handcheck') { // check then tell back to parent i'm ready to get your nextPush message
        let parentOrigin = data.parentOrigin;
        if (true /*pathNameRef.current === "/dashboard"/*runInFrameRef.current*/) {
          console.log(`Got hand check #${data.try} from ${parentOrigin}, send back i'm ready`);
          if (parentOrigin.startsWith("file:")) {
            parentOrigin = "*";
          }
          window.parent.postMessage({ type: 'emb_handcheck', id: data.id, resp: `ready` }, '*');
        } else {
          console.log(`Got hand check #${data.try} from ${parentOrigin}, but i'm not ready`);
        }
      } else if (data.type == 'auth') {
        const lastUserId = curUserIdRef?.current;
        const jwtToken = data.data.token;
        const user = data.data.user;
        const wpid = data.data.wpid;
        const initTags = data.data.initTags;
        const roomId = data.data.roomId;
        const isUserChange = Utils.ToNumber(lastUserId, 0) != Utils.ToNumber(user.userId, -1);
        Utils.JwtTokenSet(jwtToken);
        if (isUserChange) {
          dispatch(setCurrentUser(user));
        }

        if (user.userType === UserTypes.Employee) {
          localStorage.setItem(SKeys.EmbActiveTab, TABS.WORKPLACE);
          localStorage.setItem(SKeys.EmbInitWpTag, JSON.stringify(initTags));
          localStorage.setItem(SKeys.InitWpFilterNoClose, "1");
          if (wpid) {
            localStorage.setItem(SKeys.RedirectWpId, wpid);
            localStorage.setItem(SKeys.InitWpId, wpid);
          }
        } else if (user.userType === UserTypes.Customer) {
          localStorage.setItem(SKeys.EmbActiveTab, TABS.CHAT);
          localStorage.setItem(SKeys.EmbMemRoomId, roomId);
          localStorage.setItem(SKeys.EmbMemRoomAutoSel, "1");
          localStorage.setItem(SKeys.EmbInFrame, "1");
        } else if (user.userType === UserTypes.Supplier) {
          localStorage.setItem(SKeys.EmbActiveTab, TABS.CHAT_SUP);
          localStorage.setItem(SKeys.EmbMemRoomId, roomId);
          localStorage.setItem(SKeys.EmbMemRoomAutoSel, "1");
          localStorage.setItem(SKeys.EmbInFrame, "1");
        }

        if (isUserChange || pathNameRef.current !== "/dashboard") {
          console.log('User is changed, then redirect to home page:', user);
          dispatch(setCurrentUser(user));
          window.location.href = "/dashboard";
        } else { // user is not change and already login, then dispatch change to current instance
          console.log(`User is not changed, then update current view [${pathNameRef.current}]`);
          if (user.userType === UserTypes.Employee) { // workplace

            if (activeTabRef.current != TABS.WORKPLACE) dispatch(changeTab(TABS.WORKPLACE));
            dispatch(setIsEmbChatOnly(wpid ? true : false));
            if (wpid) {
              dispatch(setActivePostId2(wpid, null, null, null, null, "Emb set postid"));
            } else {
              dispatch(setActivePostId2(null, null, null, null, null, "Emp clear post id"));
              dispatch(setFilterSelected(initTags, false));
            }
          } else if (user.userType === UserTypes.Customer) { // chat
            if (activeTabRef.current != TABS.CHAT) dispatch(changeTab(TABS.CHAT));
            dispatch(setActiveGroupId(roomId));
            dispatch(changeSelectedChat(roomId));
            dispatch(getChatUserConversations2(roomId, null, null, null, null, null, "Chat embedded"));
          } else if (user.userType === UserTypes.Supplier) {// chat supplier
            console.error("Not yet support for supplier at App.tsx");
          }
        }
      } else if (data.type == 'logout') {      
        // 20251113 change to not logout for test case user often logout
        // dispatch(clearCurrentUser("App.tsx.handleMessage.logout", "Logout from app.tsx handle message then redirect to /logoutex?a"));
        // await Utils.LogDb("Logout from App.tsx because get logout message on handleMessage", 1, "App.tsx299", Utils.GetDeviceId());
        // window.location.href = "/logoutex?a";
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);



  document.title = process.env.REACT_APP_NAME as string;

  window.alert = (message: string, type: SweetAlertIcon = 'info') => {
    if (message == "Failed to fetch") {
      console.error("Failed to fetch");
    } else {
      CustomAlert(message, type);
    }
  };
  
  return <Routes />;
};


export default App;
